import { FormExternalApi, formsExternalApi } from './api';
import { buildStartTransactionFields, FieldMappings } from './startTransaction';

export type CompletePayoutParams = {
  formId: number;
  payoutId: string;
  formValues: Record<string, unknown>;
  fieldMappings?: FieldMappings | null;
  idempotencyKey?: string;
};

/**
 * Hosted payout form submit — HTTP only (no payment-page socket for payouts yet).
 * Maps form fields then POSTs via forms constructor → core admin/payouts/complete-from-form.
 */
export async function completePayout(params: CompletePayoutParams): Promise<unknown> {
  const { formId, payoutId, formValues, idempotencyKey } = params;
  return formsExternalApi.completePayout(formId, payoutId, formValues, idempotencyKey);
}

/** Re-export field builder for callers that want mapped fields client-side. */
export { buildStartTransactionFields };
export type { FieldMappings, FormExternalApi };
